import { render, staticRenderFns } from "./DayFooter.vue?vue&type=template&id=5d9c56e6&scoped=true"
import script from "./DayFooter.vue?vue&type=script&lang=js"
export * from "./DayFooter.vue?vue&type=script&lang=js"
import style0 from "./DayFooter.vue?vue&type=style&index=0&id=5d9c56e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c56e6",
  null
  
)

export default component.exports